import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import CardCurrentConditions from './CardCurrentConditions';
import CardIdealConditions from './CardIdealConditions';
import CardCurrentWeatherConditions from '../overview/CardCurrentWeatherConditions';
import ForecastChart from '../overview/ForecastChart';
import Collapse from '@mui/material/Collapse';
import Button from '@mui/material/Button';

const SpotDetail = ({spot, waveForecast, waveStationForecast, weather}) => {

    const wavesConditionsSummary = spot.wavesConditionsSummary;
    const score = spot.score;
    const [expanded, setExpanded] = useState(true);

    const handleExpandClick = () =>{ 
        setExpanded(!expanded);
    }
  
    return (
        <Box sx={{ width: '100%'}}>
        <Stack spacing={1}>
            
           <Card sx={{ border: '1px solid silver' }} >
                <CardMedia
                component="img"
                alt={`${spot.spotImage}`}
                height="140"
                image={`${spot.spotImage}`}
                />
                <CardActions>
                <a href={`https://www.youtube.com/watch?v=${spot.videoId}`}>Watch Popular Videos</a>
                </CardActions>
                <CardContent>
                    <Typography gutterBottom variant="h4" component="div">
                        {spot.spotName}
                    </Typography>
                    <Collapse in={expanded} timeout="auto" unmountOnExit >
                        <div style={{ color: "grey", fontSize: 14, fontStyle: 'italic', fontWeight: 'bold'  }}> Analysis generated by AI:<br/></div>
                        <Typography variant="body2" color="text.secondary">
                            <span style={{ color: score, fontSize: 20 }}>• </span>
                            <span style={{ fontSize: 10 }}>{wavesConditionsSummary}</span>
                        </Typography>
                    </Collapse>
                    <CardActions>
                        <Button size="small" onClick={handleExpandClick}>AI waves analysis</Button>
                    </CardActions>
                </CardContent>
            </Card> 
            <div>
                <Grid container spacing={1}>
                    <Grid item md={12} xs={12}>
                        <CardCurrentConditions spot={spot}/>
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <CardCurrentWeatherConditions weather={weather}/>
                    </Grid>
                    <Grid item xs={12}>
                        <ForecastChart waveStationForecast={waveStationForecast} forecast={waveForecast} chartTitle="Waves Forecast - 16 Days" />
                    </Grid>
                    <Grid item md={12} xs={12}>
                        <CardIdealConditions spot={spot}/>
                    </Grid>
                </Grid>
            </div>
        </Stack>
        </Box>
        
    );
};

export default SpotDetail;